import React from 'react';
import { Card, Col, Row } from 'reactstrap'
import { ItemList, AddSelectedItems, SimulateItem, PreviewItem } from './AuthorItemsCards'
import { Link } from 'react-router-dom'

export default class AuthorItems extends React.Component {

    state = {
        activeCard : '',
        singleItem: null
    }

    toggleRightCol = (activeCard) => {
        console.log(activeCard)
        this.setState(state => ({ activeCard : activeCard === state.activeCard ? '' : activeCard }))
    }

    handleView = (singleItem) => {
        this.setState({singleItem})
    }

    render() {
        const { activeCard, singleItem } = this.state;
        return (
            <Card className="course-edit-container">
                <Link to="/author/courses"><span className='breadcrums'>{'< Course'}</span></Link>
                <h3 className="heading pb-2">View and Edit Items</h3>

                <Row>
                    <Col md={6} xs={12}>
                        <ItemList activeCard={activeCard} handleView={this.handleView} toggleRightCol={this.toggleRightCol} />
                    </Col>
                    <Col md={6} xs={12}>
                        
                        {activeCard === 'addSelectedItems' && (
                            <span>
                                <AddSelectedItems toggleRightCol={this.toggleRightCol} />
                            </span>
                        )}

                        {activeCard === 'PreviewItem' && (
                            <span>
                                <PreviewItem singleItem={singleItem} />
                            </span>
                        )}

                        {activeCard === 'SimulateItem' && (
                            <span>
                                <SimulateItem singleItem={singleItem} />
                            </span>
                        )}
                    </Col>

                </Row>

            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Users/Authors/AuthorItems.js